import { useEffect, useState } from 'react';


//Custom hook for page visibility
const usePageVisibility = () => {
    const [isVisible, setIsVisible] = useState(true);
    
    // User has switched back to the tab
	const onFocus = () => {
	    setIsVisible(true);
	};
	
	// User has switched away from the tab (AKA tab is hidden)
	const onBlur = () => {
	    setIsVisible(false);
	};

    useEffect(() => {
		window.addEventListener("focus", onFocus);
        window.addEventListener("blur", onBlur);

        // Specify how to clean up after this effect:
        return () => {
            window.removeEventListener("focus", onFocus);
            window.removeEventListener("blur", onBlur);
        };
    }, []);

    return isVisible;
};

export default usePageVisibility;